(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["otk-coverage-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('otk-kit-builder-v2'))
  customElements.define(
    'otk-kit-builder-v2',
    class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        const listenerOptions = { signal: this.controller.signal };
        this.form = this.querySelector('form');
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent || '[]');
        this.busy = false;
        this.shadeValues = {};
        this.catalog = {
          Ford: {
            standard: 'Fiesta|Focus|Fusion|Mustang|Taurus|F-150|F-250|F-350|Ranger|Maverick',
            suv: 'Escape|Edge|Explorer|Bronco|Bronco Sport|Mustang Mach-E',
            large: 'Expedition|Expedition MAX|Flex',
          },
          Chevrolet: {
            standard:
              'Malibu|Impala|Cruze|Sonic|Spark|Camaro|Corvette|Colorado|Silverado 1500|Silverado 2500 HD|Silverado 3500 HD',
            suv: 'Trax|Trailblazer|Equinox|Blazer',
            large: 'Tahoe|Suburban|Traverse',
          },
          GMC: {
            standard: 'Canyon|Sierra 1500|Sierra 2500 HD|Sierra 3500 HD',
            suv: 'Terrain|Acadia',
            large: 'Yukon|Yukon XL',
          },
          Toyota: {
            standard: 'Corolla|Camry|Avalon|Prius|GR86|Supra|Tacoma|Tundra',
            suv: 'RAV4|Corolla Cross|C-HR|Highlander|4Runner|Venza|bZ4X',
            large: 'Sequoia|Land Cruiser|Grand Highlander|Sienna',
          },
          Honda: {
            standard: 'Civic|Accord|Fit|Insight|Ridgeline',
            suv: 'CR-V|HR-V|Passport|Prologue',
            large: 'Pilot|Odyssey',
          },
          Nissan: {
            standard: 'Altima|Sentra|Maxima|Versa|Leaf|Z|Frontier|Titan',
            suv: 'Rogue|Rogue Sport|Kicks|Murano|Xterra|Ariya',
            large: 'Armada|Pathfinder|Quest',
          },
          Ram: { standard: '1500|1500 Classic|2500|3500', suv: '', large: '' },
          Dodge: {
            standard: 'Charger|Challenger|Dart|Avenger|Dakota',
            suv: 'Hornet|Journey',
            large: 'Durango|Grand Caravan',
          },
          Jeep: {
            standard: 'Gladiator',
            suv: 'Wrangler|Wrangler Unlimited|Cherokee|Grand Cherokee|Compass|Renegade|Liberty|Patriot',
            large: 'Grand Cherokee L|Wagoneer|Grand Wagoneer',
          },
          Hyundai: {
            standard: 'Elantra|Sonata|Accent|Veloster|Ioniq|Ioniq 6|Santa Cruz',
            suv: 'Tucson|Santa Fe|Kona|Venue|Ioniq 5',
            large: 'Palisade',
          },
          Kia: {
            standard: 'Forte|K4|K5|Optima|Rio|Stinger',
            suv: 'Soul|Seltos|Sportage|Sorento|Niro|EV6',
            large: 'Telluride|Carnival|Sedona|EV9',
          },
          Subaru: {
            standard: 'Impreza|Legacy|WRX|BRZ',
            suv: 'Crosstrek|Forester|Outback|Solterra',
            large: 'Ascent',
          },
          Mazda: {
            standard: 'Mazda3|Mazda6|MX-5 Miata',
            suv: 'CX-3|CX-30|CX-5|CX-50|CX-70',
            large: 'CX-9|CX-90',
          },
          Volkswagen: {
            standard: 'Jetta|Passat|Golf|GTI|Arteon|Beetle',
            suv: 'Tiguan|Taos|ID.4',
            large: 'Atlas|Atlas Cross Sport|ID. Buzz',
          },
          BMW: {
            standard: '2 Series|3 Series|4 Series|5 Series|7 Series|8 Series|i4|i5|i7',
            suv: 'X1|X2|X3|X4|X5|X6|iX',
            large: 'X7',
          },
          Audi: { standard: 'A3|A4|A5|A6|A7|A8|S3|S4|S5', suv: 'Q3|Q4 e-tron|Q5|Q8|Q8 e-tron', large: 'Q7' },
          'Mercedes-Benz': {
            standard: 'A-Class|C-Class|E-Class|S-Class|CLA|CLS',
            suv: 'GLA|GLB|GLC|GLE|G-Class|EQB|EQE SUV',
            large: 'GLS|EQS SUV',
          },
          Lexus: { standard: 'IS|ES|GS|LS|RC', suv: 'UX|NX|RX|GX|RZ', large: 'LX|TX' },
          Acura: { standard: 'ILX|TLX|Integra|TL', suv: 'RDX', large: 'MDX' },
          Infiniti: { standard: 'Q50|Q60|G35|G37', suv: 'QX30|QX50|QX55', large: 'QX60|QX80' },
          Buick: {
            standard: 'Regal|LaCrosse|Verano',
            suv: 'Encore|Encore GX|Envision|Envista',
            large: 'Enclave',
          },
          Cadillac: {
            standard: 'CT4|CT5|CTS|ATS|XTS',
            suv: 'XT4|XT5|Lyriq',
            large: 'XT6|Escalade|Escalade ESV',
          },
          Lincoln: {
            standard: 'MKZ|Continental',
            suv: 'Corsair|Nautilus|MKC|MKX',
            large: 'Aviator|Navigator|Navigator L|MKT',
          },
          Chrysler: { standard: '200|300', suv: '', large: 'Pacifica|Voyager|Town & Country' },
          Mitsubishi: {
            standard: 'Lancer|Mirage',
            suv: 'Outlander|Outlander Sport|Eclipse Cross',
            large: '',
          },
        };
        this.makes = [
          'Acura',
          'Alfa Romeo',
          'AMC',
          'Aston Martin',
          'Audi',
          'Bentley',
          'BMW',
          'Bugatti',
          'Buick',
          'Cadillac',
          'Chevrolet',
          'Chrysler',
          'Daewoo',
          'Daihatsu',
          'DeLorean',
          'Dodge',
          'Eagle',
          'Ferrari',
          'Fiat',
          'Fisker',
          'Ford',
          'Genesis',
          'Geo',
          'GMC',
          'Honda',
          'Hummer',
          'Hyundai',
          'INEOS',
          'Infiniti',
          'Isuzu',
          'Jaguar',
          'Jeep',
          'Karma',
          'Kia',
          'Koenigsegg',
          'Lamborghini',
          'Land Rover',
          'Lexus',
          'Lincoln',
          'Lotus',
          'Lucid',
          'Maserati',
          'Mazda',
          'McLaren',
          'Mercedes-Benz',
          'Mercury',
          'Merkur',
          'MINI',
          'Mitsubishi',
          'Nissan',
          'Oldsmobile',
          'Pagani',
          'Peugeot',
          'Plymouth',
          'Polestar',
          'Pontiac',
          'Porsche',
          'Ram',
          'Rivian',
          'Rolls-Royce',
          'Saab',
          'Saturn',
          'Scion',
          'Smart',
          'Sterling',
          'Subaru',
          'Suzuki',
          'Tesla',
          'Toyota',
          'VinFast',
          'Volkswagen',
          'Volvo',
          'Yugo',
        ];
        this.parts = {
          front: {
            coverage: 'Front two windows',
            label: 'Front door window pair',
            count: '2 windows · 1 pair',
            shade: 'Front window shade',
          },
          rear: {
            coverage: 'Rear door windows',
            label: 'Rear door window pair',
            count: '2 windows · 1 pair',
            shade: 'Rear door window shade',
          },
          quarter: {
            coverage: 'Quarter windows',
            label: 'Quarter / cargo windows',
            count: '1 vehicle-specific set',
            shade: 'Quarter window shade',
          },
          back: {
            coverage: 'Back glass',
            label: 'Rear windshield / back glass',
            count: '1 rear-glass set',
            shade: 'Back glass shade',
          },
          allrear: { shade: 'Rear windows + back glass shade' },
          strip: { shade: 'Windshield strip shade' },
          windshield: { shade: 'Full windshield shade' },
          sunroof: { shade: 'Sunroof / moonroof shade' },
        };
        this.field('make').length = 1;
        this.makes.forEach((make) => this.field('make').add(new Option(make, make)));
        this.field('make').add(new Option('Other / specialty vehicle', 'other'));
        this.details = this.querySelector('.otk2-specific');
        this.details.addEventListener(
          'toggle',
          () => {
            this.querySelector('.otk2-chevron').textContent = this.details.open ? '−' : '+';
            this.querySelector('[data-expand-hint]').textContent = this.details.open
              ? 'Select window groups below · tap to collapse'
              : this.mode() === 'custom'
                ? 'Custom selection active · tap to expand'
                : 'Tap to expand window choices';
            if (this.details.open && this.mode() !== 'custom') {
              this.field('coverage').value = 'custom';
              this.update();
            }
          },
          listenerOptions,
        );
        this.form.addEventListener(
          'click',
          (e) => {
            const button = e.target.closest('[data-qty]');
            if (!button || button.disabled) return;
            const input = this.field('qty_' + button.dataset.qty);
            input.value = Math.max(1, Math.min(99, (Number(input.value) || 1) + Number(button.dataset.step)));
            this.update();
          },
          listenerOptions,
        );
        this.form.addEventListener(
          'change',
          (e) => {
            if (e.target.name === 'make') this.models();
            if (['make', 'model'].includes(e.target.name)) this.field('body').value = '';
            if (e.target.name === 'coverage' && this.mode() !== 'custom') this.details.open = false;
            this.update();
          },
          listenerOptions,
        );
        this.form.addEventListener(
          'input',
          (e) => {
            if (e.target.name.startsWith('shade_')) this.shadeValues[e.target.name.slice(6)] = e.target.value;
            this.update();
          },
          listenerOptions,
        );
        this.form.addEventListener('submit', (e) => this.submit(e), listenerOptions);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.ready = false;
      }
      field(name) {
        return this.form.elements.namedItem(name);
      }
      mode() {
        return this.field('coverage').value;
      }
      modelsFor(make) {
        return Object.entries(this.catalog[make] || {})
          .flatMap(([tier, models]) =>
            models
              .split('|')
              .filter(Boolean)
              .map((model) => ({ model, tier })),
          )
          .sort((a, b) => a.model.localeCompare(b.model));
      }
      manualModel() {
        return (
          !!this.field('make').value &&
          (!this.modelsFor(this.field('make').value).length || this.field('model').value === 'other')
        );
      }
      makeValue() {
        return this.field('make').value === 'other'
          ? this.field('make_entry').value.trim()
          : this.field('make').value;
      }
      modelValue() {
        return this.manualModel() ? this.field('model_entry').value.trim() : this.field('model').value;
      }
      tier() {
        const listed = this.field('model').selectedOptions[0]?.dataset.tier;
        if (listed) return listed;
        if (!this.manualModel()) return '';
        const body = this.field('body').value;
        if (body === 'SUV / crossover') return 'suv';
        if (body === 'Large SUV' || body === 'Minivan') return 'large';
        return [
          '2-door coupe',
          '4-door sedan',
          'Hatchback / wagon',
          'Regular cab pickup',
          'Extended cab pickup',
          'Crew cab pickup',
        ].includes(body)
          ? 'standard'
          : '';
      }
      money(cents) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        }).format(cents / 100);
      }
      pricedCoverage(coverage) {
        const suffix = { suv: 'SUV', large: 'Large SUV or Minivan' }[this.tier()];
        return suffix &&
          ['Quarter windows', 'Back glass', 'Rear sides', 'All side windows', 'Rear 2/3 kit'].includes(
            coverage,
          )
          ? coverage + ' - ' + suffix
          : coverage;
      }
      variant(coverage) {
        const name = this.pricedCoverage(coverage);
        return this.variants.find((v) => v.option1 === this.dataset.film && v.option2 === name);
      }
      fullName(strip = false) {
        return this.tier()
          ? 'Full vehicle' +
              (strip ? ' + strip' : '') +
              ' - ' +
              { standard: 'Sedan or Pickup', suv: 'SUV', large: 'Large SUV or Minivan' }[this.tier()]
          : '';
      }
      models() {
        const select = this.field('model');
        select.replaceChildren(new Option('Choose model', ''));
        const models = this.modelsFor(this.field('make').value);
        select.disabled = !models.length;
        for (const { model, tier } of models) {
          const option = new Option(model, model);
          option.dataset.tier = tier;
          select.add(option);
        }
        if (models.length) select.add(new Option('Other model / specialty glass', 'other'));
      }
      selection() {
        const mode = this.mode(),
          wind = this.field('windshield').value,
          strip = wind === 'strip',
          rows = [];
        const row = (coverage, label, count, shades, quantity = 1) =>
          rows.push({ coverage, label, count, shades, quantity, variant: this.variant(coverage) });
        let bundledStrip = false;
        if (mode === 'custom' && ['sides', 'rearfull', 'rearsides'].includes(this.dataset.packageKey)) {
          const packages = {
            sides: { coverage: 'All side windows', shades: ['front', 'rear', 'quarter'] },
            rearfull: { coverage: 'Rear 2/3 kit', shades: ['rear', 'quarter', 'back'] },
            rearsides: { coverage: 'Rear sides', shades: ['rear', 'quarter'] },
          };
          const kit = packages[this.dataset.packageKey];
          row(kit.coverage, this.dataset.packageLabel, this.dataset.packageDescription, kit.shades);
        } else if (mode === 'full') {
          row(
            this.fullName(strip),
            'All side windows + rear glass' + (strip ? ' + windshield strip' : ''),
            'Vehicle-specific side + rear kit' + (strip ? ' · 1 strip' : ''),
            strip ? ['front', 'allrear', 'strip'] : ['front', 'allrear'],
          );
          bundledStrip = strip;
        } else {
          for (const [key, part] of Object.entries(this.parts)) {
            if (!part.coverage) continue;
            if (
              (mode === 'front' && key === 'front') ||
              (mode === 'custom' && this.field('part_' + key).checked)
            ) {
              const quantity =
                mode === 'custom'
                  ? Math.max(1, Math.min(99, Math.floor(Number(this.field('qty_' + key).value) || 1)))
                  : 1;
              const bundle = key === 'front' && strip;
              row(
                bundle ? 'Front two + strip' : part.coverage,
                part.label + (bundle ? ' + windshield strip' : ''),
                part.count + (bundle ? ' · 1 strip' : ''),
                bundle ? [key, 'strip'] : [key],
                bundle ? 1 : quantity,
              );
              if (bundle) {
                bundledStrip = true;
                if (quantity > 1) row(part.coverage, part.label, part.count, [key], quantity - 1);
              }
            }
          }
        }
        if (strip && !bundledStrip) row('Windshield strip', 'Top windshield strip', '1 strip', ['strip']);
        if (wind === 'full') row('Full windshield', 'Full front windshield', '1 windshield', ['windshield']);
        if (this.field('sunroof').checked)
          row('Sunroof / moonroof', 'Sunroof / moonroof', '1 standard roof panel', ['sunroof']);
        return rows;
      }
      stripPrice() {
        if (this.mode() === 'custom' && ['sides', 'rearfull', 'rearsides'].includes(this.dataset.packageKey))
          return this.variant('Windshield strip')?.price;
        let base, bundle;
        if (this.mode() === 'full') {
          base = this.variant(this.fullName());
          bundle = this.variant(this.fullName(true));
          if (!base || !bundle) {
            base = this.variant('Front two windows');
            bundle = this.variant('Front two + strip');
          }
        } else if (this.mode() === 'front' || this.field('part_front').checked) {
          base = this.variant('Front two windows');
          bundle = this.variant('Front two + strip');
        } else return this.variant('Windshield strip')?.price;
        return base && bundle ? bundle.price - base.price : null;
      }
      renderShades(rows) {
        const keys = [...new Set(rows.flatMap((r) => r.shades))],
          signature = this.dataset.film + '|' + keys.join('|');
        if (signature !== this.shadeSignature) {
          this.querySelectorAll('[data-shades] select').forEach(
            (s) => (this.shadeValues[s.name.slice(6)] = s.value),
          );
          this.shadeSignature = signature;
          const holder = this.querySelector('[data-shades]');
          holder.replaceChildren();
          keys.forEach((key) => {
            const label = document.createElement('label');
            label.append(document.createTextNode(this.parts[key].shade));
            const select = document.createElement('select');
            select.name = 'shade_' + key;
            select.required = true;
            select.add(new Option('Choose shade', ''));
            (this.dataset.film === 'Ceramic' ? ['5%', '15%', '35%', '50%'] : ['5%', '15%', '35%']).forEach(
              (s) => select.add(new Option(s, s)),
            );
            select.value = this.shadeValues[key] || '';
            label.append(select);
            holder.append(label);
          });
        }
        this.querySelector('[data-no-shades]').hidden = keys.length > 0;
        return keys;
      }
      update() {
        this.field('make_entry').disabled = this.field('make').value !== 'other';
        this.field('model_entry').disabled = !this.manualModel();
        let quantitiesReady = true;
        for (const key of ['front', 'rear', 'quarter', 'back']) {
          const input = this.field('qty_' + key),
            active = this.mode() === 'custom' && this.field('part_' + key).checked;
          input.disabled = !active;
          if (active && !input.validity.valid) quantitiesReady = false;
          this.querySelectorAll('[data-qty=' + key + ']').forEach(
            (button) =>
              (button.disabled =
                !active ||
                (button.dataset.step === '-1' ? Number(input.value) <= 1 : Number(input.value) >= 99)),
          );
        }
        const rows = this.selection(),
          tier = this.tier(),
          keys = this.renderShades(rows);
        this.querySelectorAll('[data-price]').forEach((el) => {
          const v = this.variant(el.dataset.price);
          el.textContent = v?.price > 0 ? this.money(v.price) : 'Unavailable';
        });
        const full = this.variant(this.fullName());
        this.querySelector('[data-full-price]').textContent =
          full?.price > 0 ? this.money(full.price) : 'Select vehicle';
        const strip = this.stripPrice();
        this.querySelector('[data-strip-price]').textContent =
          strip > 0 ? '+ ' + this.money(strip) : 'Unavailable';
        for (const [selector, coverage] of [
          ['[data-windshield-price]', 'Full windshield'],
          ['[data-sunroof-price]', 'Sunroof / moonroof'],
        ]) {
          const v = this.variant(coverage);
          this.querySelector(selector).textContent =
            v?.price > 0 ? '+ ' + this.money(v.price) : 'Unavailable';
        }
        this.querySelector('[data-other]').hidden =
          this.field('make').value !== 'other' && this.field('model').value !== 'other';
        this.querySelector('[data-class]').textContent = tier
          ? 'Full-kit pricing: ' +
            { standard: 'sedan / pickup', suv: 'SUV / crossover', large: 'large SUV / minivan' }[tier] +
            '.'
          : 'Select your vehicle to see full-kit pricing.';
        this.querySelector('[data-special-note]').hidden =
          this.field('windshield').value !== 'full' && !this.field('sunroof').checked;
        const list = this.querySelector('[data-summary]');
        list.replaceChildren();
        rows.forEach((row) => {
          const li = document.createElement('li'),
            text = document.createElement('span'),
            small = document.createElement('small'),
            price = document.createElement('b');
          text.textContent = (row.quantity > 1 ? row.quantity + ' × ' : '') + row.label;
          small.textContent = row.count + (row.quantity > 1 ? ' per set' : '');
          text.append(small);
          price.textContent =
            row.variant?.price > 0 ? this.money(row.variant.price * row.quantity) : 'Select vehicle';
          li.append(text, price);
          list.append(li);
        });
        if (!rows.length) {
          const li = document.createElement('li');
          li.textContent = 'Choose at least one window group, windshield option, or sunroof.';
          list.append(li);
        }
        const hasPrices = rows.length && rows.every((r) => r.variant?.price > 0),
          available = hasPrices && rows.every((r) => r.variant.available),
          total = rows.reduce((sum, r) => sum + (r.variant?.price || 0) * r.quantity, 0);
        this.querySelector('[data-total]').textContent = hasPrices
          ? this.money(total)
          : rows.length
            ? 'Select vehicle'
            : 'Select coverage';
        const vehicleReady =
            !!tier &&
            !!this.makeValue() &&
            !!this.modelValue() &&
            !!this.field('trim').value.trim() &&
            this.field('trim').validity.valid &&
            !!this.field('year').value &&
            this.field('year').validity.valid &&
            !!this.field('body').value,
          shadesReady = keys.every((k) => !!this.field('shade_' + k).value);
        const button = this.querySelector('[type=submit]');
        button.disabled =
          this.busy || !quantitiesReady || !rows.length || !vehicleReady || !shadesReady || !available;
        button.textContent = this.busy
          ? 'Adding…'
          : !quantitiesReady
            ? 'Enter whole quantities from 1 to 99'
            : !rows.length
              ? 'Select your coverage to continue'
              : !vehicleReady
                ? 'Complete your vehicle details to continue'
                : !available
                  ? 'Selected coverage unavailable'
                  : !shadesReady
                    ? 'Choose your tint shades'
                    : 'Add kit to cart';
      }
      async submit(e) {
        e.preventDefault();
        if (this.busy) return;
        this.update();
        if (this.querySelector('[type=submit]').disabled || !this.form.reportValidity()) return;
        const rows = this.selection(),
          base = {
            'Vehicle year': this.field('year').value,
            'Vehicle make': this.makeValue(),
            'Vehicle model': this.modelValue(),
            'Body style / cab': this.field('body').value,
          };
        if (this.field('trim').value.trim()) base['Fitment notes'] = this.field('trim').value.trim();
        const items = rows.map((row) => {
          const properties = { ...base, Coverage: row.coverage, 'Window coverage': row.count };
          row.shades.forEach((key) => (properties[this.parts[key].shade] = this.field('shade_' + key).value));
          return { id: row.variant.id, quantity: row.quantity, properties };
        });
        this.busy = true;
        this.update();
        this.form.inert = true;
        const status = this.querySelector('[data-status]');
        status.textContent = '';
        try {
          const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
            signal: this.controller.signal,
          });
          const result = await response.json();
          if (!response.ok)
            throw new Error(result.description || 'Could not add your kit. Please try again.');
          window.location.assign(root + 'cart');
        } catch (error) {
          this.form.inert = false;
          status.textContent = error.message;
          this.busy = false;
          this.update();
        }
      }
    },
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["otk-shade-choices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('otk-shade-choices')) {
  let instance = 0;
  customElements.define(
    'otk-shade-choices',
    class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.instance ||= ++instance;
        this.pickers ||= new WeakMap();
        this.observer = new MutationObserver(() => this.enhance());
        this.observer.observe(this, { childList: true, subtree: true });
        this.enhance();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }
      enhance() {
        const owner = this.closest('otk-kit-builder-v2');
        const source = owner?.querySelector('[data-otk-shade-copy]');
        if (!source) return;
        let copy;
        try {
          copy = JSON.parse(source.textContent);
        } catch {
          return;
        }
        const selects = [...this.querySelectorAll('select[name^="shade_"]')];
        if (!selects.length) return;
        if (!this.querySelector('.otk-shade-help')) {
          const help = document.createElement('p');
          help.className = 'otk-shade-help';
          help.textContent = copy.help + ' ' + copy.preview;
          this.prepend(help);
        }
        for (const select of selects) {
          if (this.pickers.has(select)) continue;
          const label = select.closest('label');
          if (!label) continue;
          const options = [...select.options].filter((option) => option.value && !option.disabled);
          if (!options.length || options.some((option) => !copy[option.value])) continue;
          const group = document.createElement('fieldset');
          group.className = 'otk-shade-group';
          const legend = document.createElement('legend');
          legend.textContent = [...label.childNodes]
            .filter((node) => node.nodeType === 3)
            .map((node) => node.textContent)
            .join('')
            .trim();
          group.append(legend);
          const choices = document.createElement('div');
          choices.className = 'otk-shade-grid';
          const radios = [];
          for (const option of options) {
            const card = document.createElement('label');
            card.className = 'otk-shade-choice';
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'otk-choice-' + this.instance + '-' + select.name;
            radio.value = option.value;
            radio.required = select.required;
            radio.checked = select.value === option.value;
            const swatch = document.createElement('span');
            swatch.className = 'otk-shade-swatch';
            swatch.setAttribute('aria-hidden', 'true');
            swatch.style.setProperty(
              '--otk-shade-opacity',
              String(1 - Number.parseInt(option.value, 10) / 100),
            );
            const percentage = document.createElement('strong');
            percentage.textContent = option.textContent;
            const description = document.createElement('span');
            description.className = 'otk-shade-description';
            description.textContent = copy[option.value];
            card.append(radio, swatch, percentage, description);
            choices.append(card);
            radios.push(radio);
          }
          choices.addEventListener('input', (event) => event.stopPropagation());
          choices.addEventListener('change', (event) => {
            const radio = event.target;
            if (!(radio instanceof HTMLInputElement) || !radio.checked) return;
            event.stopPropagation();
            select.value = radio.value;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
          select.addEventListener('change', () => {
            for (const radio of radios) radio.checked = radio.value === select.value;
          });
          group.append(choices);
          label.after(group);
          this.pickers.set(select, group);
          label.hidden = true;
        }
      }
    },
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["otk-vehicle-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('otk-vehicle-finder'))
  customElements.define(
    'otk-vehicle-finder',
    class extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const controller = (this.controller = new AbortController());
        // Load Shopify's permission reader without changing the visitor's consent.
        try {
          if (!window.Shopify?.customerPrivacy) {
            window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
          }
        } catch {
          /* Keep the builder usable if analytics is blocked. */
        }
        await customElements.whenDefined('otk-kit-builder-v2');
        if (!this.isConnected || controller.signal.aborted) return;
        this.builder = this.querySelector('otk-kit-builder-v2');
        this.form = this.querySelector('.otk-finder__vehicle');
        this.form.reset();
        this.labels = JSON.parse(this.querySelector('[data-finder-labels]').textContent);
        this.cards = [...this.querySelectorAll('[data-kit]')];
        this.finish = this.querySelector('.otk-finder__finish');
        this.status = this.querySelector('[data-finder-status]');
        const field = (name) => this.form.elements.namedItem(name);
        field('make').length = 1;
        field('body').length = 1;
        this.builder.makes.forEach((make) => field('make').add(new Option(make, make)));
        field('make').add(new Option(this.labels.other_make, 'other'));
        [...this.builder.field('body').options]
          .filter((option) => option.value)
          .forEach((option) => field('body').add(new Option(option.text, option.value)));
        this.coverageFieldset = this.builder.field('coverage')[0].closest('fieldset');
        this.coverageFieldset.hidden = true;
        const vehicleFieldset = this.builder.field('year').closest('fieldset');
        vehicleFieldset.querySelector('legend').textContent = this.labels.fitment;
        this.builder.querySelector('.otk2-films').closest('fieldset').querySelector('legend').textContent =
          this.labels.film;
        this.builder.querySelector('[data-shades]').closest('fieldset').querySelector('legend').textContent =
          this.labels.shades;
        for (const name of ['year', 'make', 'model', 'body', 'make_entry', 'model_entry'])
          this.builder.field(name).closest('label').hidden = true;
        vehicleFieldset.querySelector('[data-class]').hidden = true;
        const defaultMake = this.dataset.defaultMake;
        if (this.builder.makes.includes(defaultMake)) field('make').value = defaultMake;
        this.populateModels();
        this.lock();
        this.applySimulatorSelection();
        const options = { signal: this.controller.signal };
        this.builder.addEventListener('input', () => this.trackReadyKit(), options);
        this.builder.addEventListener('change', () => this.trackReadyKit(), options);
        this.form.addEventListener(
          'change',
          (event) => {
            this.builder.field('trim').value = '';
            if (['make', 'model'].includes(event.target.name)) field('body').value = '';
            if (event.target.name === 'make') {
              field('make_entry').value = '';
              field('model_entry').value = '';
              this.populateModels();
            }
            if (event.target.name === 'model') {
              field('model_entry').value = '';
              this.syncManualFields();
            }
            this.lock();
          },
          options,
        );
        this.form.addEventListener(
          'input',
          (event) => {
            if (['make_entry', 'model_entry'].includes(event.target.name)) this.lock();
          },
          options,
        );
        this.form.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            if (!this.form.reportValidity()) return;
            this.builder.field('year').value = field('year').value;
            this.builder.field('make').value = field('make').value;
            this.builder.models();
            this.builder.field('model').value = field('model').value;
            this.builder.field('body').value = field('body').value;
            this.builder.field('make_entry').value = field('make_entry').value.trim();
            this.builder.field('model_entry').value = field('model_entry').value.trim();
            this.builder.update();
            if (!this.builder.tier()) return;
            this.setAttribute('data-ready', '');
            this.cards.forEach((card) => (card.disabled = false));
            this.status.textContent = this.labels.unlocked;
            this.querySelector('[data-vehicle-summary]').textContent = [
              field('year').value,
              this.builder.makeValue(),
              this.builder.modelValue(),
              field('body').value,
            ].join(' · ');
            this.querySelector('.otk-finder__vehicle-summary').hidden = false;
            this.trackStep('builder_vehicle_confirmed');
            this.focusSection(this.querySelector('.otk-finder__coverage h2'));
          },
          options,
        );
        this.addEventListener(
          'click',
          (event) => {
            const card = event.target.closest('[data-kit]');
            if (card && !card.disabled && this.hasAttribute('data-ready')) this.choose(card);
            if (event.target.closest('[data-change-vehicle]')) {
              this.lock();
              field('year').focus();
              this.form.scrollIntoView({ block: 'center', behavior: this.motion() });
            }
            if (event.target.closest('[data-change-coverage]')) {
              this.finish.hidden = true;
              (
                this.cards.find((item) => item.getAttribute('aria-pressed') === 'true') || this.cards[0]
              ).focus();
            }
            const film = event.target.closest('.otk2-films a');
            if (film) {
              event.preventDefault();
              this.builder.dataset.film = film.href.includes('ceramic-tint') ? 'Ceramic' : 'Carbon';
              this.builder.shadeValues = {};
              this.builder.shadeSignature = null;
              this.builder
                .querySelectorAll('.otk2-films a')
                .forEach((link) => link.setAttribute('aria-current', link === film ? 'page' : 'false'));
              this.builder.update();
            }
            this.trackReadyKit();
          },
          options,
        );
      }
      field(name) {
        return this.form.elements.namedItem(name);
      }
      populateModels() {
        const make = this.field('make').value;
        const select = this.field('model');
        select.replaceChildren(
          new Option(make ? this.labels.choose_model : this.labels.choose_make_first, ''),
        );
        const models = this.builder.modelsFor(make);
        select.disabled = !models.length;
        for (const { model } of models) select.add(new Option(model, model));
        if (models.length) select.add(new Option(this.labels.other_model, 'other'));
        this.syncManualFields();
      }
      syncManualFields() {
        const make = this.field('make').value;
        const manualModel =
          !!make && (!this.builder.modelsFor(make).length || this.field('model').value === 'other');
        this.field('model').closest('label').hidden = !!make && !this.builder.modelsFor(make).length;
        for (const [name, active] of [
          ['make_entry', make === 'other'],
          ['model_entry', manualModel],
        ]) {
          const input = this.field(name);
          input.closest('label').hidden = !active;
          input.disabled = !active;
          input.required = active;
        }
      }
      // Use the Google & YouTube app's existing tag. Never configure or load a second tag.
      trackStep(name) {
        try {
          if (window.Shopify?.designMode || this.trackedSteps?.has(name)) return;
          const privacy = window.Shopify?.customerPrivacy;
          if (!privacy?.analyticsProcessingAllowed?.() || !Array.isArray(window.dataLayer)) return;
          const parameters = { send_to: 'G-FGEMJV4XFR' };
          if (new URLSearchParams(window.location.search).get('otk_tracking_debug') === '1') {
            parameters.debug_mode = true;
          }
          // gtag commands use Arguments objects; reuse the app's default data layer.
          const send = function () {
            window.dataLayer.push(arguments);
          };
          send('event', name, parameters);
          (this.trackedSteps ||= new Set()).add(name);
        } catch {
          // Analytics must never interrupt configuring or buying a kit.
        }
      }
      trackReadyKit() {
        if (
          !this.finish.hidden &&
          !this.builder.busy &&
          !this.builder.querySelector('[type=submit]').disabled &&
          this.builder.form.checkValidity()
        ) {
          this.trackStep('builder_kit_ready');
        }
      }
      applySimulatorSelection() {
        if (this.simulatorSelectionApplied) return;
        this.simulatorSelectionApplied = true;
        const params = new URLSearchParams(window.location.search);
        const film = params.get('film')?.toLowerCase();
        if (!['carbon', 'ceramic'].includes(film)) return;
        const builder = this.builder;
        builder.dataset.film = film === 'ceramic' ? 'Ceramic' : 'Carbon';
        builder.querySelectorAll('.otk2-films a').forEach((link) => {
          const selected = link.href.includes('ceramic-tint') === (film === 'ceramic');
          link.setAttribute('aria-current', selected ? 'page' : 'false');
        });
        builder.shadeSignature = null;
        builder.update();
        const allowed = film === 'ceramic' ? ['5', '15', '35', '50'] : ['5', '15', '35'];
        for (const key of ['front', 'allrear', 'rear', 'quarter', 'back']) {
          const value = params.get(key === 'front' ? 'front' : 'rear');
          if (!allowed.includes(value)) continue;
          builder.shadeValues[key] = value + '%';
          const select = builder.field('shade_' + key);
          if (select) select.value = value + '%';
        }
        builder.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.initialized = false;
        this.simulatorSelectionApplied = false;
      }
      motion() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      }
      focusSection(heading) {
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ block: 'start', behavior: this.motion() });
      }
      lock() {
        this.removeAttribute('data-ready');
        this.cards.forEach((card) => {
          card.disabled = true;
          card.setAttribute('aria-pressed', 'false');
        });
        this.finish.hidden = true;
        this.querySelector('.otk-finder__vehicle-summary').hidden = true;
        this.querySelector('.otk-finder__contact').hidden = true;
        this.status.textContent = this.field('model_entry').required
          ? this.labels.manual_model
          : this.labels.locked;
      }
      choose(card) {
        const key = card.dataset.kit;
        this.builder.dataset.packageKey = ['sides', 'rearfull', 'rearsides'].includes(key) ? key : '';
        this.builder.dataset.packageLabel = card.querySelector('strong').textContent;
        this.builder.dataset.packageDescription = card.querySelector(
          '.otk-finder__card-copy > span',
        ).textContent;
        const selected =
          {
            back: ['back'],
            sides: ['front', 'rear', 'quarter'],
            rearfull: ['rear', 'quarter', 'back'],
            rearsides: ['rear', 'quarter'],
          }[key] || [];
        this.builder.field('coverage').value = key === 'full' ? 'full' : key === 'front' ? 'front' : 'custom';
        for (const part of ['front', 'rear', 'quarter', 'back']) {
          this.builder.field('part_' + part).checked = selected.includes(part);
          this.builder.field('qty_' + part).value = '1';
        }
        this.builder.field('windshield').value =
          key === 'strip' ? 'strip' : key === 'windshield' ? 'full' : 'none';
        this.builder.field('sunroof').checked = false;
        this.coverageFieldset.hidden = key !== 'replacement';
        this.builder.details.open = key === 'replacement';
        this.builder.querySelector('.otk2-optional').open = key === 'strip' || key === 'windshield';
        this.builder.update();
        this.cards.forEach((item) => item.setAttribute('aria-pressed', String(item === card)));
        this.querySelector('[data-selected-kit]').textContent =
          card.querySelector('strong').textContent +
          ' · ' +
          this.querySelector('[data-vehicle-summary]').textContent;
        this.finish.hidden = false;
        this.trackStep('builder_coverage_selected');
        this.trackReadyKit();
        this.focusSection(this.finish.querySelector('h2'));
      }
    },
  );
  } catch(e) { console.error(e); }
})();

})();
